import {ApplicationRef, Component, OnInit} from '@angular/core';
import {TdoTableModel} from '../../../tdo-controls/common/tdo-table/models/tdo-table.model';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {Globals} from '../../../globals';
import {OperatoriesService} from '../operatories/operatories.service';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormArray} from '@angular/forms';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {StaticDataService} from '../../../services/static-data.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {CheckoutProcessorConfigurationService} from './checkout-processor-configuration.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CfgAutoCheckOutModel} from '../../../models/configuration/cfg-task-auto-checkout.model';


@Component({
  selector: 'app-checkout-processor-configuration',
  templateUrl: './checkout-processor-configuration.component.html',
  styleUrls: ['./checkout-processor-configuration.component.scss']
})
export class CheckoutProcessorConfigurationComponent implements OnInit {
  tableModel: TdoTableModel;
  clientList: TdoClientConfigurationModel[] = [];
  locationList: ClientLocationDataModel[] = [];

  EditCheckOut: CfgAutoCheckOutModel[] = [];
  OriginalCheckOutProcessor: CfgAutoCheckOutModel[] = [];

  checkOutTasksEnums: EnumValidValueItemModel[] = [];
  checkOutTasksEnumsReplacement: EnumValidValueItemModel[] = [];
  selectedCheckOutTask: EnumValidValueItemModel[] = [];
  selectedCheckOutTaskReplacement: EnumValidValueItemModel[] = [];

  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  isLoading = true;
  myForm: UntypedFormGroup;

  deletedIndex: number;

  constructor(private opsService: OperatoriesService,
              private snackBar: MatSnackBar,
              private globals: Globals,
              private fb: UntypedFormBuilder,
              private staticDataService: StaticDataService,
              private checkOutProcessorConfigService: CheckoutProcessorConfigurationService,
              private appRef: ApplicationRef) { }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      checkOutProcedure: this.fb.array([])
    });

    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupPage();
        }
      });
    } else {
      this.setupPage();
    }
  }

  setupPage(){

    this.opsService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }

      this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
        this.locationList = ldata;

        if (this.locationList.length > 0) {
          const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
          if (currentLoc) {
            this.selectedLocation = currentLoc;
          } else {
            this.selectedLocation = this.locationList[0];
          }
          this.onChangeLoc('');
        }

        this.isLoading = false;
      });

    }, err => {
      console.log(err);
      this.isLoading = false;
    });
    this.checkOutTasksEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAutoCheckOutTasks');
    this.checkOutTasksEnumsReplacement = this.checkOutTasksEnums;
  }


  get checkOutProcedureForms(){
    return this.myForm.get('checkOutProcedure') as UntypedFormArray;
  }
  onChangeClient(e): void {
    this.isLoading = true;
    // this.selectedWorkstation = null;
    this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      // this.operatoriesList = null;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        this.selectedLocation = this.locationList[0];
        this.onChangeLoc('');
      }
      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
    });

  }

  async onChangeLoc(e) {
    console.log('Selected location is' + this.selectedLocation.LOCID.toString());
    const promises: any[] = [
      this.checkOutProcessorConfigService.getCheckOutProcessor(this.selectedLocation.LOCID.toString()).toPromise()
    ];
    const results: any[] = await Promise.all(promises);
    this.OriginalCheckOutProcessor = results[0];
    this.clearCheckOutProcessorList();
    if (this.OriginalCheckOutProcessor.length > 0){
     // this.checkOutProcedureForms.clear();
      this.LoadOriginalCheckOutProcessor();
    }
   else{
      //this.checkOutProcedureForms.clear();
      this.selectedCheckOutTask = [];
      this.selectedCheckOutTaskReplacement = [];

    }
    //console.log('check out processor for this LOCID: ' + JSON.stringify(this.OriginalCheckOutProcessor));
  }
  onChangeCheckOutTask(event, index: any){
    this.selectedCheckOutTask[index] = event.value;
    this.deletedIndex = this.checkOutTasksEnumsReplacement.indexOf(event.value);
    this.selectedCheckOutTaskReplacement[index] = event.value;
    console.log('delete Index: ' + this.deletedIndex);
    // this.checkOutTasksEnumsReplacement.splice(deletedIndex)
  }

  clearCheckOutProcessorList() {
    // (this.checkOutProcedureForms as any) = [];
    this.checkOutProcedureForms.clear();
  }

  AddElement(){
    // this.checkOutTasksEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAutoCheckOutTasks');
    const checkOutProcedure = this.fb.group({
     checkOutProcedure: []
   });
    // console.log('index to be deleted: ' + this.deletedIndex);
   /* if (this.deletedIndex !== undefined)
    {
      this.checkOutTasksEnumsReplacement.splice(this.deletedIndex);
    }*/
    this.checkOutProcedureForms.push(checkOutProcedure);
  }

  deleteProcedure(i)
  {
    console.log('Deleting index: '  + (i + 1));
    //this.checkOutProcedureForms.removeAt(i);
    //(this.myForm.controls.checkOutProcedure as FormArray).removeAt(i);
    //this.appRef.tick();
    const value = this.checkOutProcedureForms.value;
    moveItemInArray(this.selectedCheckOutTask, i, value.length - 1);
    this.checkOutProcedureForms.removeAt(i);
    this.selectedCheckOutTaskReplacement.splice(value.length - 1);
    /*
    this.checkOutProcedureForms.setValue(
      value.slice(0, i).concat(
        value.slice(i + 1),
      ).concat(value[i]),
    );

    this.checkOutProcedureForms.removeAt(value.length - 1);*/








    // console.log('item deleted:' + JSON.stringify(this.selectedCheckOutTask[i]));
    // this.selectedCheckOutTask.splice(i);
    // moveItemInArray(this.selectedCheckOutTask, i, i + 1);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.selectedCheckOutTask, event.previousIndex, event.currentIndex);
  }

  LoadOriginalCheckOutProcessor(){
    let i: number = 0;
    for (const item of this.OriginalCheckOutProcessor) {
      const checkOutProcedure = this.fb.group({
        checkOutProcedure: []
      });
      this.selectedCheckOutTask[i] =   this.checkOutTasksEnums.find(({ ValidValueItemId }) => ValidValueItemId === item.enumAutoCheckOutTasksID);
      this.checkOutProcedureForms.push(checkOutProcedure);
      i++;
    }
    this.selectedCheckOutTaskReplacement = [];
    this.selectedCheckOutTaskReplacement = this.selectedCheckOutTask;

  }

  DefaultCheckOutProcedures(){
    let i: number = 0;
    this.clearCheckOutProcessorList();
    for (const item of this.checkOutTasksEnums) {
      const checkOutProcedure = this.fb.group({
        checkOutProcedure: []
      });
      this.selectedCheckOutTask[i] =   this.checkOutTasksEnums.find(({ ItemOrder }) => ItemOrder === i + 1);
      this.checkOutProcedureForms.push(checkOutProcedure);
      i++;
    }
    this.selectedCheckOutTaskReplacement = [];
    this.selectedCheckOutTaskReplacement = this.selectedCheckOutTask;

  }


  SaveCheckOutProcedures(){
    console.log(this.selectedCheckOutTaskReplacement);
    let CheckOutModel;
    for (let i = 0; i < this.selectedCheckOutTaskReplacement.length; i++) {
      CheckOutModel = new CfgAutoCheckOutModel();
      CheckOutModel.LOCID = this.selectedLocation.LOCID;
      CheckOutModel.TaskOrder = i;
      CheckOutModel.enumAutoCheckOutTasksID = JSON.parse(JSON.stringify(this.selectedCheckOutTaskReplacement[i])).ValidValueItemId.toString();
      this.EditCheckOut.push(CheckOutModel);
    }

    this.checkOutProcessorConfigService.saveCheckOutProcessors(this.EditCheckOut).subscribe(saved => {
      if (saved)
      {
        // save successful
       // if (showConfirmation) {
          this.createMessage('Processor saved', 'Success');
          this.EditCheckOut = [];
          //this.selectedCheckOutTaskReplacement = [];
          //this.selectedCheckOutTask = [];
        // }

        // if new processor
        /*const processor = this.processors.filter(a => a.PaymentProcessorId === saved.PaymentProcessorId);
        if (processor.length === 0)
        {
          this.processors.push(saved);
        }

        this.refreshTableViewData(this.processors);
        this.isSaved = true;
        this.selectedProcessor = saved;
        this.setSelectedProcessorRevert();
        this.isLoading = false;*/
      }
      //this.selectedCheckOutTaskReplacement = [];
      //this.selectedCheckOutTask = [];
    }, err => {
      this.createMessage('Error saving processor', 'Error');
      this.isLoading = false;
    });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

}
